import axios from 'axios';

/**
 * Email History API Utilities
 * Shared utilities for creating API instances and helper functions
 */

/**
 * Create an axios instance for email history API endpoints
 * @param {string} basePath - Base API path (e.g., '/api3.2/emailHistory' or '/api3.2/canmail')
 * @returns {axios.AxiosInstance}
 */
export function createEmailHistoryApiInstance(basePath) {
  const baseURL = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? `http://localhost:10000${basePath}`
    : basePath;

  return axios.create({
    baseURL,
    timeout: 30000, // 30 seconds
  });
}

/**
 * Get the X-Forwarded-Host header value from API URL
 * @param {string} apiUrl - The API base URL
 * @returns {string} The host value for the header
 */
export function getForwardedHost(apiUrl) {
  if (!apiUrl) {
    return window.location.host;
  }
  
  if (apiUrl.startsWith('/')) {
    return window.location.host;
  }
  
  try {
    const parsedUrl = new URL(apiUrl);
    return parsedUrl.host || window.location.host;
  } catch (error) {
    return window.location.host;
  }
}

